import { useEffect, useState } from "react";
import { currentTabHandler } from "../../store/slices/Staffs/staffsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const useStaffsTab = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("activeTab");
  const [isChecked, setIsChecked] = useState(false);
  const [activeTabLeft, setActiveTabLeft] = useState("");
  const [activeTabWidth, setActiveTabWidth] = useState("");

  const { currentTab } = useSelector((state) => state.project);
  const handleClickTab = (e, tab) => {
    const callback = () => {
      setActiveTab(tab);
      setActiveTabLeft(e.target.offsetLeft);
      setActiveTabWidth(e.target.offsetWidth);
      if (tab === "contractStaffTab") {
        navigate("/dashboard/staffs/contract");
      } else {
        navigate("/dashboard/staffs/permanant");
      }
    };
    dispatch(currentTabHandler({ tab: tab, callback: callback }));
  };

  useEffect(() => {
    let activeTabSelect = document.querySelectorAll(".tabActive");
    setActiveTabLeft(activeTabSelect[0]?.offsetLeft);
    setActiveTabWidth(activeTabSelect[0]?.offsetWidth);
  }, []);

  return {
    activeTab,
    isChecked,
    activeTabLeft,
    activeTabWidth,
    setActiveTab,
    setIsChecked,
    setActiveTabLeft,
    setActiveTabWidth,
    handleClickTab,
    currentTab,
  };
};
